import { useMutation, useQueryClient } from "@tanstack/react-query";

import { errorHandler } from "#app/monitoring/errorHandler";
import { showErrorToast } from "#app/notifications";
import { addDefaultOnboardingProcessStepsApi } from "#modules/onboardingV2/infra/addDefaultOnboardingProcessSteps.api";
import { onboardingProcessStepsQuery } from "#modules/onboardingV2/infra/onboardingProcessSteps.query";

export const useAddDefaultOnboardingProcessSteps = () => {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation({
    mutationFn: addDefaultOnboardingProcessStepsApi,
    onSuccess: () => {
      void queryClient.invalidateQueries(onboardingProcessStepsQuery());
    },
    onError: (err: Error) => {
      showErrorToast({ title: "Une erreur est survenue" });
      errorHandler(err);
    },
  });

  return { addDefaultOnboardingProcessSteps: mutateAsync, isPending };
};
